import { render, staticRenderFns } from "./editRules.vue?vue&type=template&id=4d45b7f1&scoped=true&"
import script from "./editRules.vue?vue&type=script&lang=js&"
export * from "./editRules.vue?vue&type=script&lang=js&"
import style0 from "./editRules.vue?vue&type=style&index=0&id=4d45b7f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45b7f1",
  null
  
)

export default component.exports